import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

const contentFrameVariants = cva("mx-auto w-full min-w-0", {
  variants: {
    size: {
      compact: "max-w-[var(--content-compact)]",
      task: "max-w-[var(--content-task)]",
      workbench: "max-w-[var(--content-workbench)]",
      full: "max-w-none"
    }
  },
  defaultVariants: {
    size: "task"
  }
});

export interface ContentFrameProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof contentFrameVariants> {}

export function ContentFrame({ className, size, ...props }: ContentFrameProps) {
  return (
    <div
      data-slot="content-frame"
      className={cn(contentFrameVariants({ size }), className)}
      {...props}
    />
  );
}
